export default __webpack_public_path__ + "static/media/icon-sos.54a50e14.svg";